import { type ODSearchExternalWidgetInit } from './odsearch/ODSearchExternal.types'
import * as odSearchExternal from './odsearch/ODSearchExternalApp'

document.dispatchEvent(new CustomEvent('WidgetsExternal.ODSearchExternal.Ready', { detail: odSearchExternal }))

declare global {
  // eslint-disable-next-line @typescript-eslint/consistent-type-definitions
  interface Window {
    WidgetsExternal: {
      odsearch: {
        init: ODSearchExternalWidgetInit
      }
    }
  }
}
